import React, { useState, useEffect } from 'react';
import { LandingPage } from './components/LandingPage';
import { AnalysisWorkspace } from './components/AnalysisWorkspace';
import { getStoredUser, removeToken, verifyToken } from './services/api';

function App() {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Check for saved user and verify token on mount
  useEffect(() => {
    const checkAuth = async () => {
      const savedUser = getStoredUser();
      
      if (savedUser) {
        // Verify token is still valid
        const isValid = await verifyToken();
        
        if (isValid) {
          setUser(savedUser);
        } else {
          // Token expired, clear storage
          removeToken();
        }
      }
      
      setIsLoading(false);
    };
    
    checkAuth();
  }, []);

  const handleLoginSuccess = (userData) => {
    setUser(userData);
    // Token is already saved by api.js login function
  };

  const handleLogout = () => {
    setUser(null);
    removeToken();
  };

  // Show loading while checking auth
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #1a1f36 0%, #0d1117 100%)'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '3px solid rgba(59, 130, 246, 0.3)',
          borderTopColor: '#3B82F6',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} />
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // If user is logged in, show the workspace
  if (user) {
    return <AnalysisWorkspace user={user} onLogout={handleLogout} />;
  }

  // Otherwise show landing page
  return <LandingPage onLoginSuccess={handleLoginSuccess} />;
}

export default App;
